var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xml-upload-request-result"},[_c('span',{staticClass:"tag",class:_vm.klass},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }